export const CODE_LANG_ENVS = [
  'voxengine',
  'avatarengine',
  'html',
  'javascript',
  'nodejs',
  'voxengine.partial',
];
